import Wrapper from "../../Layout/Wrapper/wrapper";
import { Link } from "gatsby";
import "./styles.scss";
import { FooterShopProps } from "./types";

const FooterShop = ({ navItems, logoPath }: FooterShopProps) => {
  return (
    <footer className="footer">
      <Wrapper className="footer__wrapper">
        <Link to="/">
          <img
            className="footer__logo"
            src={logoPath}
            alt="logo"
          />
        </Link>
        <nav className="footer__nav">
          <ul className="footer__navItems">
            {navItems.map((item, index) => {
              return (
                <li
                  key={`navItem-${index}`}
                  className="footer__navItem">
                  <Link
                    className="footer__navLink"
                    to={`${item.link}`}>
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </Wrapper>
    </footer>
  );
};

export default FooterShop;
